export default function onComponentRendered(componentGetFn, onRendered, ms = 100) {
  const interval = setInterval(() => {
    const component = componentGetFn();
    if (component) {
      onRendered(component);
      clearInterval(interval);
    }
  }, ms ?? 100);
}
